export const Constant = {
  MIN_OPACITY: 0,
  MAX_OPACITY: 1,

  DEFAULT_DURATION_IN_MS: 750,
  DEFAULT_DELAY_IN_MS: 0,
};
